import InfiniteScroll from "react-infinite-scroll-component";
import { useSelector } from "react-redux";
import Message from "./Message";

export default function Messages({ messages = [], fetchMore, hasMore }) {
  const { user } = useSelector((state) => state.auth) || {};
  const { email } = user || {};
  return (
    <div
      id="scrollableDiv"
      style={{
        height: "full",
        overflow: "auto",
        display: "flex",
        flexDirection: "column-reverse",
      }}
    >
      {/*Put the scroll bar always on the bottom*/}
      <InfiniteScroll
        dataLength={messages?.length}
        next={fetchMore}
        style={{ display: "flex", flexDirection: "column-reverse" }} //To put endMessage and loader to the top.
        inverse={true} //
        hasMore={hasMore}
        loader={<h4>Loading...</h4>}
        scrollableTarget="scrollableDiv"
      >
        <div className="relative w-full p-6  flex flex-col-reverse">
          <ul className="space-y-2">
            {messages
              .slice()
              .sort((a, b) => a.timestamp - b.timestamp)
              .map((message) => {
                const { message: lastMessage, id, sender } = message || {};

                const justify = sender.email !== email ? "start" : "end";

                return (
                  <Message key={id} justify={justify} message={lastMessage} />
                );
              })}
          </ul>
        </div>
      </InfiniteScroll>
    </div>
  );
}
